import React from "react";
import { II } from "../../components/common/Icons";
import { PM_NAV } from "../../data/pmData";
import SearchBar from "../../components/common/SearchBar";
import NotificationBell from "../../components/common/NotificationBell";
import { AvatarDisplay } from "../../components/common/AvatarUpload";
import { useAuth } from "../../context/AuthContext";import "../../assets/styles/PM/PMTopbar.css";

function PMTopbar({ activeView, setActiveView, onLogout }) {
  const { user } = useAuth();
  const a = activeView;

  const pageLabels = { dashboard: "Dashboard", projects: "Projects", progress: "Team Progress", leave: "Leave Requests", calendar: "Calendar", announce: "Announcements", reports: "HR Reports", hrrequests: "HR Requests", offboardingmanagement: "Offboarding Management", chat: "Team Chat", permissions: "Permissions", advances: "Salary Advances", notifications: "Notifications", notes: "Notes", people: "People", profile: "My Profile" };

  return (
    <div className="TB">
      <div className="TB-bc">
        Project Manager {II("right", 14)} <b>{pageLabels[a] || PM_NAV.find((n) => n.k === a)?.l || "Dashboard"}</b>
      </div>
      <div className="pmtopbar-inline-1">
        <SearchBar portalName="PM" resetKey={activeView} />
        <div onClick={() => setActiveView && setActiveView("chat")} title="Chat" className="pmtopbar-inline-2">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
        </div>
        <NotificationBell onNavigate={setActiveView} />
        <AvatarDisplay src={user?.avatar} name={user?.name} size={34} onClick={() => setActiveView && setActiveView("profile")} className="pmtopbar-inline-3" />
        <div className="TB-ib pmtopbar-inline-4" onClick={onLogout} title="Sign Out">
          {II("logout")}
        </div>
      </div>
    </div>);

}

export default PMTopbar;
